module.exports = __webpack_public_path__ + "static/img/new-exam-choose-picture1.0ab7d8bd.png";